"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRule = addRule;
exports.autocomplete = autocomplete;
exports.breach = breach;
exports.comment = comment;
exports.confirm = confirm;
exports["default"] = void 0;
exports.getAll = getAll;
exports.getComments = getComments;
exports.userSearch = userSearch;

var _api = _interopRequireWildcard(require("./api"));

var _tokenStorage = _interopRequireDefault(require("./lib/tokenStorage"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var base = "".concat(process.env.REACT_APP_SHERLOCK_URL, "/api/breach");
var baseComment = "".concat(process.env.REACT_APP_SHERLOCK_URL, "/api/comment");
var rule = "".concat(process.env.REACT_APP_SHERLOCK_URL, "/api/rule/createWeb");

var token = _tokenStorage["default"].get();

function getAll(filters) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DESC';
  var orderBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'created_at';
  var skip = arguments.length > 3 ? arguments[3] : undefined;
  return _api["default"].post("".concat(base, "/list"), _objectSpread(_objectSpread({}, filters), {}, {
    skip: skip,
    order: order,
    orderBy: orderBy
  })).then(_api.extractData)["catch"](_api.errorHandler);
}

function getComments(expertId) {
  return _api["default"].get("".concat(baseComment, "?expertId=").concat(expertId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function confirm(id, status) {
  return _api["default"].put("".concat(base), {
    id: id,
    confirmed: status
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function addRule(data) {
  var instance = _axios["default"].create({
    headers: {
      authorization: "Bearer ".concat(token)
    }
  });

  return instance.post("".concat(rule), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function autocomplete(keyword) {
  return _api["default"].get("/api/expert/typeahead-search?q=".concat(keyword)).then(_api.extractData)["catch"](_api.errorHandler);
}

function userSearch(keyword) {
  return _api["default"].get("/api/employee/typeahead?q=".concat(keyword)).then(_api.extractData)["catch"](_api.errorHandler);
}

function breach(data) {
  return _api["default"].post(base, data).then(_api.extractData)["catch"](_api.errorHandler);
}

function comment(data) {
  return _api["default"].post(baseComment, data).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  getAll: getAll,
  confirm: confirm,
  autocomplete: autocomplete,
  userSearch: userSearch,
  breach: breach,
  comment: comment,
  getComments: getComments,
  addRule: addRule
};
var _default = api;
exports["default"] = _default;